import React from "react";
import Checkbox from "../checkbox";

export default function CheckboxField({ field, form: {touched, errors}, ...restProps }) {
  return <Checkbox {...field} {...restProps} checked={field.value || false} id={field.name} />
}